/* eslint no-param-reassign: "off", no-console: "off" */

const dashboardStore = {
  state: {
    selectedDashboard: null,
    dashboards: [],
  },
  mutations: {
    fetchWidgets(state, payload) {
      state.widgets = payload;
    },
    addDashboard(state, payload) {
      state.selectedDashboard = payload;
      state.dashboards.push(payload);
    },
    deleteDashboard(state, payload) {
      state.selectedDashboard = state.dashboards.length ? state.dashboards[0] : null;
      state.dashboards = state.dashboards.filter(d => d.id != payload);
    },
    setSelectedDashboard(state, payload) {
      state.selectedDashboard = payload;
    },
    fetchDashboards(state, payload) {
      state.dashboards = payload;
    },
    fetchLastDashboard(state, payload) {
      state.selectedDashboard = state.dashboards.find(d => d.id == payload);
    },
    clearDashboards(state) {
      state.dashboards = [];
      state.selectedDashboard = null;
    }
  },
  actions: {
    async addDashboard({ commit }, payload) {
      const model = { id: Math.random().toString(36).slice(2), name: payload, widgets: [] }
      // eslint-disable-next-line no-undef
      await $dashStore.setItem(model.id, model);
      // eslint-disable-next-line no-undef
      await $userStore.setItem('lastDashboard', model.id);
      commit('addDashboard', model);
    },
    // eslint-disable-next-line no-empty-pattern
    async setLastDashboard({}, payload) {
      // eslint-disable-next-line no-undef
      await $userStore.setItem('lastDashboard', payload);
    },
    async deleteDashboard({ commit }, payload) {
      // eslint-disable-next-line no-undef
      await $dashStore.removeItem(payload);
      commit('deleteDashboard', payload);
    },
    fetchDashboards({ commit }) {
      const dashes = [];
      // eslint-disable-next-line no-undef
      return $dashStore.iterate((value) => { dashes.push(value) })
        .then(() => {
          commit('fetchDashboards', dashes);
          return true;
        });
    },
    async fetchLastDashboard({ commit }) {
      // eslint-disable-next-line no-undef
      const ld = await $userStore.getItem('lastDashboard');
      commit('fetchLastDashboard', ld);
    },
    // eslint-disable-next-line no-empty-pattern
    async updateDashboard({}, payload) {
      // eslint-disable-next-line no-undef
      await $dashStore.setItem(payload.id, payload);
    },
    async resetDashboards({ commit, dispatch }) {
      // eslint-disable-next-line no-undef
      await $dashStore.clear();
      commit('clearDashboards');
      await dispatch('addDashboard', 'My Dashboard')
    },
    /**
     * Pins an entity to Dashboard
     * @param {Object} payload - The entity object
     */
    async pinToDash({ state, dispatch }, payload) {
      let existingWidgets = state.selectedDashboard.widgets;
      if (!existingWidgets) existingWidgets = [];
      
      // Determine the size
      let size = null;
      let type = null;
      switch (payload.entityType) {
        case 'remote':
        case 'device':
          type = 'single';
          size = '1x1';
          break;
        case 'remoteList':
        case 'deviceList':
          type = 'list';
          size = '3x6';
          break;
        default:
          type = 'single';
          size = '1x1';
          break;
      }

      // Determine location
      let location = null;
      // TODO: determine the first available column row ex: [0,2] means first column, 3rd row
      location = [0, 0];

      existingWidgets.push({
        entityType: payload.entityType,
        entityId: payload.entity ? payload.entity.id : null,
        type,
        location,
        size
      });

      await dispatch('updateDashboard', state.selectedDashboard);
      return true;
    }
  },
  getters: {

  }
}
export default dashboardStore;
